import { ProductService } from "../../services/ProductService";
import { getFormattedPrice } from "../../utils";

const ProductAddedPopupContent = ({ product, showVAT }) => {
  return (
    <>
      {product && (
        <>
          {!(product.bgColor && product.bgColor.label) ? (
            <p className="notification-title">Tilføjet til indkøbskurven</p>
          ) : (
            <p className="notification-title">
              Tilføjet til indkøbskurven med {product.bgColor.label} farve
            </p>
          )}
        </>
      )}
      <div className="d-flex align-items-center">
        <div className="image-wrapper">
          <img src={product?.item.img} alt="" />
        </div>
        <div className="content-wrapper">
          <p>{product?.item.title}</p>
          <p>
            {`${(product?.qty || 0) > 1 ? `${product?.qty} x ` : ""}${
              product &&
              getFormattedPrice(
                showVAT ? product.item.price : product.item.priceNoVat
              )
            }`}
          </p>
          {(product?.qty || 0) > 1 && (
            <p>
              Total: {ProductService.getFormattedTotalPrice(product, showVAT)}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductAddedPopupContent;
